import { render, staticRenderFns } from "./PublicationVideoItemSearch.vue?vue&type=template&id=9c9b40d0&scoped=true&lang=pug&"
import script from "./PublicationVideoItemSearch.vue?vue&type=script&lang=js&"
export * from "./PublicationVideoItemSearch.vue?vue&type=script&lang=js&"
import style0 from "./PublicationVideoItemSearch.vue?vue&type=style&index=0&id=9c9b40d0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9b40d0",
  null
  
)

export default component.exports